function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import options, { write, remove } from "../../apiV2/ProviderOptions";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/share";
import "rxjs/add/operator/catch";
import pickBy from "lodash/pickBy";
import forEach from "lodash/forEach";
import isFunction from "lodash/isFunction";
var BaseProvider = /*#__PURE__*/ function() {
    "use strict";
    function BaseProvider() {
        _classCallCheck(this, BaseProvider);
        this._subscriptions = {};
        this._observable = null;
        this._reduxStore = null;
    }
    var _proto = BaseProvider.prototype;
    // This function will process incoming message.
    //  observable => the "caller-channel"
    //  data       => the naked data we are receiving
    _proto._onMessage = function _onMessage(uid, msg) {
        var type = msg && msg.type ? msg.type : null;
        this._subscriptions[uid] = this._subscriptions[uid] || [];
        switch(type){
            case "sub":
                if (this._canAcceptMessagesForChannel(msg.data)) {
                    if (msg.options) {
                        write(uid, msg.options);
                    }
                    this._subscriptions[uid].push(msg.data);
                    this.onSubscribed(uid, msg.data);
                }
                break;
            case "unsub":
                if (this._canAcceptMessagesForChannel(msg.data)) {
                    delete this._subscriptions[uid];
                    this.onUnsubscribed(uid, msg.data);
                    remove(uid);
                }
                break;
            default:
                {
                    var _msg_type_split = _slicedToArray(msg.type.split(":", 2), 2), channel = _msg_type_split[0], msgId = _msg_type_split[1];
                    if (this._canAcceptMessagesForChannel(channel)) {
                        this.onMessageReceived(uid, channel, msgId, msg.data, msg.transactionId);
                    }
                }
                break;
        }
    };
    _proto.getObservable = function getObservable() {
        var _this = this;
        if (this._observable === null) {
            this._observable = Observable.create(function(observable) {
                // Method to send something to observers:
                _this.publish = function(uid, channel, msgId, data, transactionId) {
                    console.log(channel, msgId, data);
                    observable.next({
                        type: channel + ":" + msgId,
                        payload: data,
                        client: uid,
                        sessionId: uid,
                        transactionId: transactionId
                    });
                };
                // Method to fanout Messages to all subscribed clients.
                //  for specified channel.
                _this.fanout = function(channel, msgId, data) {
                    forEach(pickBy(_this._subscriptions, function(subscription) {
                        return subscription.indexOf(channel) !== -1;
                    }), function(subscription, uid) {
                        var _d = isFunction(data) ? data(options(uid)) : data;
                        if (isFunction(data) && _d.then) {
                            _d.then(function(_data) {
                                console.log("resolved 0.0", _data);
                                _this.publish(uid, channel, msgId, _data);
                            }).catch(console.error);
                        } else {
                            _this.publish(uid, channel, msgId, _d);
                        }
                    });
                };
                return function() {
                    _this._subscriptions = {};
                    _this._observable = null;
                };
            }).share(); // shared, only one instance of this observable!
        }
        return this._observable;
    };
    // Write something to the provider
    _proto.write = function write(uid, d) {
        this._onMessage(uid, d);
    };
    // Will be overwritten by first active observable.
    _proto.fanout = function fanout() {
        console.warn("BaseProvider#fanout there is no subscribtion active to fan out messages.");
    };
    // Will be overwritten by first active observable.
    _proto.publish = function publish() {
        console.warn("BaseProvider#publish there is no subscription active to publish to.");
    };
    // The actual onMessage method, that should be overwritten to handle
    //  incomming messages.
    _proto.onMessageReceived = function onMessageReceived(uid, channel, msgId, data, transactionId) {};
    // The actual onSubscribe method.
    //  Invoked when a client subscribes to a channel.
    //  Needs to be overwritten by a subclass.
    _proto.onSubscribed = function onSubscribed(uid, channel) {};
    _proto.onUnsubscribed = function onUnsubscribed(uid, channel) {};
    _proto.registerReduxStore = function registerReduxStore(store) {
        this._reduxStore = store;
    };
    _proto.reduxMiddleware = function reduxMiddleware(store, action, uid) {
        return action;
    };
    _proto.release = function release() {
        if (this._observable) {
            this._observable.dispose();
            this._observable = null;
        }
    };
    _proto._canAcceptMessagesForChannel = function _canAcceptMessagesForChannel(channel) {
        return this.constructor.providedChannels.indexOf(channel) !== -1;
    };
    _proto.DataStruct = function DataStruct() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return {};
    };
    return BaseProvider;
}();
BaseProvider.providedChannels = [];
export default BaseProvider;
